import React, { useState, useRef } from "react";

export default function FilterOverlay({eleRef}) {

    return (
        <div className={`vaccFilter-overlay filter-popup ${eleRef.state.isClosing ? "fade-out" : "fade-in"}`}>
            {/* <div className="filtermodal" > */}
            <div className={`filtermodal `}>
                <div className="closeFilterBtn" onClick={eleRef.closeFilter}>
                    <img className="closeBtnImg" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/closeBtn.png"></img>
                </div>
                <div className="filterBox">
                    <div className="filterTitle M18_21">Filter</div>
                    <div className={`filterby R16_21  ${eleRef.state.activeStatus == 'overdue'?'activeFilter':''} `} 
                        onClick={() => eleRef.showVaccineStatus('overdue')} 
                    >
                        Overdue Vaccines 
                    </div>
                    <div className={`filterby R16_21  ${eleRef.state.activeStatus == 'upcoming'?'activeFilter':''} `} 
                        onClick={() => eleRef.showVaccineStatus('upcoming')}
                    >
                        Upcoming Vaccines 
                    </div>
                    <div className={`filterby R16_21  ${eleRef.state.activeStatus == 'given'?'activeFilter':''} `} 
                        onClick={() => eleRef.showVaccineStatus('given')}
                    > 
                        Done Vaccines 
                    </div>
                    <div className={`filterby R16_21  ${eleRef.state.activeStatus == 'all'?'activeFilter':''} `} 
                        onClick={() => eleRef.showVaccineStatus('all')}
                    > 
                        Show all Vaccines 
                    </div>
                </div>
            </div>
        </div>
    )

}